// src/components/mindworkout/sections/WorkoutCTASection.js
import React from 'react';
import styled from 'styled-components';
import DownloadButton from '../../ui/DownloadButton';

const SectionContainer = styled.section`
    padding: 5rem 2rem;
    background: linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 100%);
    color: white;
    text-align: center;
`;

const ContentWrapper = styled.div`
    max-width: 800px;
    margin: 0 auto;
`;

const Title = styled.h2`
    font-size: 2.5rem;
    margin-bottom: 1rem;
`;

const Description = styled.p`
    font-size: 1.25rem;
    margin-bottom: 3rem;
    opacity: 0.95;
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
`;

const Stats = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    margin-top: 4rem;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const StatItem = styled.div``;

const StatNumber = styled.div`
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
`;

const StatLabel = styled.div`
    font-size: 1.1rem;
    opacity: 0.9;
`;

const WorkoutCTASection = () => {
    return (
        <SectionContainer>
            <ContentWrapper>
                <Title>지금 시작하세요!</Title>
                <Description>
                    매일 10분, 당신의 정신력이 달라집니다.<br/>
                    첫 7일은 무료로 모든 기능을 체험해보세요.
                </Description>
                <ButtonGroup>
                    <DownloadButton platform="ios" />
                    <DownloadButton platform="android" />
                </ButtonGroup>

                <Stats>
                    <StatItem>
                        <StatNumber>50,000+</StatNumber>
                        <StatLabel>활발한 사용자</StatLabel>
                    </StatItem>
                    <StatItem>
                        <StatNumber>4.8 ⭐</StatNumber>
                        <StatLabel>평균 평점</StatLabel>
                    </StatItem>
                    <StatItem>
                        <StatNumber>22개</StatNumber>
                        <StatLabel>다양한 훈련</StatLabel>
                    </StatItem>
                </Stats>
            </ContentWrapper>
        </SectionContainer>
    );
};

export default WorkoutCTASection;
